enum CompanySize {
  SMALL = 'Small',
  LARGE = 'Large',
}
export default CompanySize
